import { Directive, ElementRef, HostListener, Output, EventEmitter, inject, Renderer2, OnDestroy } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: true
})
export class ClickOutsideElementDirective implements OnDestroy {
  private elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private listener : (() => void) | null = null;
  isFirstClick = true;
  @Output() clickOutside = new EventEmitter<any>();

  constructor(){
    this.listener = this.renderer.listen('document', 'click', (event: Event) => {
      if(this.isFirstClick){
        this.isFirstClick = false;
        return;
      }
      if(!this.elementRef.nativeElement.contains(event.target)){
        this.clickOutside.emit();
      }
  })


}
  ngOnDestroy(): void {
    this.listener?.();
  }
}
